import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { getSubject } from "../lib/content";
import { useGame } from "../context/GameContext";
import TopBar from "../components/TopBar";
import Mascot from "../components/Mascot";
import { speak } from "../lib/speech";
import { sound } from "../lib/sounds";
import { CheckCircle2, Play } from "lucide-react";

export default function Subject() {
  const { subjectId } = useParams();
  const navigate = useNavigate();
  const { profile } = useGame();
  const subject = getSubject(subjectId);

  useEffect(() => {
    if (subject) { const t = setTimeout(() => speak(`${subject.title}. Kies een les!`), 400); return () => clearTimeout(t); }
  }, [subject]);

  useEffect(() => {
    if (subject && profile && (profile.enabled_subjects || {})[subject.id] === false) navigate("/spelen");
  }, [subject, profile, navigate]);

  if (!subject || !profile) return null;
  const done = new Set(profile.completed_lessons || []);

  return (
    <div className="min-h-screen" style={{ background: `linear-gradient(180deg, ${subject.color}22, #F0F9FF)` }}>
      <TopBar title={subject.title} />
      <div className="mx-auto max-w-2xl px-4 pb-20 pt-2">
        <div className="flex items-center justify-center">
          <Mascot mood="idle" size={100} message={`${subject.title}! Kies een les.`} />
        </div>

        <div className="mt-4 flex flex-col gap-4">
          {subject.lessons.map((lesson, i) => {
            const isDone = done.has(`${subject.id}:${lesson.id}`);
            return (
              <motion.button
                key={lesson.id}
                data-testid={`lesson-${lesson.id}`}
                initial={{ x: -30, opacity: 0 }} animate={{ x: 0, opacity: 1 }} transition={{ delay: i * 0.1 }}
                whileHover={{ scale: 1.02, x: 4 }} whileTap={{ scale: 0.98 }}
                onClick={() => { sound.tap(); navigate(`/les/${subject.id}/${lesson.id}`); }}
                className="flex items-center gap-4 rounded-3xl bg-white p-5 shadow-lg text-left"
              >
                <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-2xl text-3xl shadow-inner"
                     style={{ background: `${subject.color}22` }}>
                  {lesson.icon}
                </div>
                <div className="flex-1">
                  <p className="font-display text-2xl font-bold text-slate-800">{lesson.title}</p>
                  <p className="text-sm font-bold text-slate-400">{lesson.intro}</p>
                </div>
                {isDone
                  ? <CheckCircle2 className="h-8 w-8 shrink-0 text-emerald-500" />
                  : <div className="flex h-11 w-11 items-center justify-center rounded-full text-white shadow-md"
                         style={{ background: subject.color }}><Play className="h-5 w-5 fill-white" /></div>}
              </motion.button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
